// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageMover_image_container__lGAFy {
    position: relative;
    width: 100%;
    height: 100%;
}

.ImageMover_img_box__KVYky {
    position: absolute;
    bottom: calc(100vh - 640px);
    left: 50%;
    transform: translateX(-50%);
}

.ImageMover_move_up_animation__cnjyQ {
    width: 102px;
    height: 102px;
    animation: ImageMover_moveUp__Kzxmm 1s linear forwards; /* 动画名称、持续时间和让动画保持结束状态 */
}

@keyframes ImageMover_moveUp__Kzxmm {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(-200px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ImageMover/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sDAAoC,EAAE,wBAAwB;AAClE;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,6BAA6B;IACjC;AACJ","sourcesContent":[".image_container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.img_box {\n    position: absolute;\n    bottom: calc(100vh - 640px);\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.move_up_animation {\n    width: 102px;\n    height: 102px;\n    animation: moveUp 1s linear forwards; /* 动画名称、持续时间和让动画保持结束状态 */\n}\n\n@keyframes moveUp {\n    from {\n        transform: translateY(0);\n    }\n    to {\n        transform: translateY(-200px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image_container": `ImageMover_image_container__lGAFy`,
	"img_box": `ImageMover_img_box__KVYky`,
	"move_up_animation": `ImageMover_move_up_animation__cnjyQ`,
	"moveUp": `ImageMover_moveUp__Kzxmm`
};
export default ___CSS_LOADER_EXPORT___;
